import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import "./index.css"
import { omegaFontsCss } from "./omega-fonts"

// Keep the self-hosted display font outside the bundle so the browser loads it
// directly from the public assets.
const style = document.createElement("style")
style.textContent = omegaFontsCss
document.head.appendChild(style)

const element = document.getElementById("root")!
const root = createRoot(element)
if (import.meta.hot) {
  import.meta.hot.data.root ??= root
}

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
